import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	loading: {
		id: 'card.common.spinner.loading',
		defaultMessage: 'Loading',
		description: 'Tooltip around an icon indicating whether card data is loading',
	},
});
